import React from "react";
import { MapPin } from "lucide-react";

export function hasMultipleBranches(items) {
  const ids = new Set((items || []).map((i) => i.branch_id).filter(Boolean));
  return ids.size > 1;
}

export default function BranchBadge({ name, show = true }) {
  if (!show || !name) return null;
  return (
    <div className="text-xs text-white/60 flex items-center gap-1 mt-1">
      <MapPin size={12} className="text-[#FFD700] shrink-0" />
      <span>Sucursal {name}</span>
    </div>
  );
}
